<template>
  <div class="card mb-3">
    <div class="card-body cg-tight">
      <div
        class="d-flex justify-content-between align-items-baseline flex-wrap gap-2"
      >
        <div class="d-flex align-items-baseline flex-wrap gap-2">
          <h3 class="cg-card-title">Own generation</h3>
          <p class="mb-0 text-body-secondary small">
            Generation facilities you own and the certificates they issue
          </p>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary ms-auto">
          Add a facility
        </button>
      </div>
      <div class="cg-halves">
        <div class="cg-half cg-rule-top">
          <p class="cg-micro mb-2">Own generation</p>
          <StatBlock value="0" unit="MWh forecast" class="mb-2" />
          <p class="mb-0 text-body-secondary small">
            No facilities registered. Register a facility you own and Soldera
            handles its registry issuance.
          </p>
        </div>
        <div class="cg-half cg-rule-top">
          <p class="cg-micro mb-2">Issuance</p>
          <div class="d-flex flex-wrap gap-3 mb-2">
            <StatBlock value="0" unit="MWh issued" />
            <StatBlock
              value="0"
              unit="MWh still expected"
              class="text-body-secondary"
            />
          </div>
          <MonthStrip :cells="emptyCells" labels />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-body cg-tight">
      <div
        class="d-flex justify-content-between align-items-baseline flex-wrap gap-2"
      >
        <div class="d-flex align-items-baseline flex-wrap gap-2">
          <h3 class="cg-card-title">Reserve</h3>
          <p class="mb-0 text-body-secondary small">
            Certificates outside this year's agreements
          </p>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary ms-auto">
          Manage reserve
        </button>
      </div>
      <div class="cg-half cg-rule-top cg-halves-gap">
        <p class="cg-micro mb-2">Not tied to an agreement</p>
        <StatBlock value="0" unit="MWh held" class="mb-2" />
        <StackedBar :segments="[]" :height="15" class="mb-2" />
        <p class="mb-0 text-body-secondary small">
          Every certificate in the account arrived under one of the agreements
          above. Carried-over and separately acquired certificates appear here.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MONTHS } from "@/compliance_groups/fixture/complianceGroupsFixture";
import type { StripCell } from "@/compliance_groups/fixture/derive";
import MonthStrip from "./MonthStrip.vue";
import StackedBar from "./StackedBar.vue";
import StatBlock from "./StatBlock.vue";

// Two illustrative cards from the prototype with no data behind them; the buttons are inert.
const emptyCells: StripCell[] = MONTHS.map((m) => ({
  label: m[0],
  period: `${m} 2026`,
  fill: "empty",
  statusLabel: "No issuance",
  tone: "pending",
  detail: [],
}));
</script>

<style scoped lang="scss">
.cg-half {
  flex: 1 1 220px;
  min-width: 0;
}
</style>
